import { PendingOrder } from './pending-order';


export class PendingOrders {

  constructor(
    public pendingOrders?: PendingOrder[],
    public totalPage?: number,
    public total?: number
  ) { }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/pending-orders.ts